import { render, staticRenderFns } from "./select-rut.vue?vue&type=template&id=72e9309d&"
import script from "./select-rut.vue?vue&type=script&lang=js&"
export * from "./select-rut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports